import React, { useState,useEffect } from "react";
import { image_url } from "../../Util/connection_strings";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { sendForm } from "../../Apis";
import Error from "../../Components/Modal.Error";
import Success from "../../Components/Modal.Success";
import { userState } from "../../Recoil/Auth";
import AOS from 'aos';
import 'aos/dist/aos.css'




export default function Contact() {
  const user = useRecoilValue(userState);
  const [data, setData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    userId: user._id,
  });


  useEffect(() => {
    AOS.init({disable: 'mobile',mirror:true});
    AOS.refresh();
  }, []);


  const { mutate, isLoading } = useMutation((data) => sendForm(data), {
    onSuccess: (res) => {
      Success(res?.data?.message);
      setData({
        name: "",
        email: "",
        subject: "",
        message: "",
        userId: user._id,
      });
    },
    onError: (err) => Error(err?.response?.data?.message),
  });

  return (
    <>
      <section className="bg-about1">
      <img
            style={{
              width: "100px",
              position: "absolute",
              left: 0,
              bottom: 0,
              zIndex: 1,
              opacity: 0.8,
            }}
            src="images/bannerLeft.png"
            alt=""
            className="img-fluid"
          />

          <img
            style={{
              width: "100px",
              position: "absolute",
              right: 0,
              top: 0,
              zIndex: 1,
              opacity: 0.8,
            }}
            src="images/bannerRight22.png"
            alt=""
            className="img-fluid"
          />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
            <div style={{zIndex: 2}} data-aos="fade-up"
                 data-aos-easing="ease-in-sine">
              <h1 className="bannerHeading2">Vendor</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="p-55-0">
        <div className="container">
         
        {/* Video Section */}
              <div className="row justify-content-center mb-5">
                <div className="col-lg-10 text-center" data-aos="fade-up" data-aos-delay="200">
                  <video width="100%" controls autoPlay>
                    <source src="images/Predivauth.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  {/* OR: Embed from YouTube */}
                  {/* 
                  <div className="embed-responsive embed-responsive-16by9">
                    <iframe
                      className="embed-responsive-item"
                      src="https://www.youtube.com/embed/VIDEO_ID"
                      allowFullScreen
                      title="Demo Video"
                    ></iframe>
                  </div>
                  */}
                      
                  </div>
                  </div>

                  </div>
      </section>
    </>
  );
}
